import Component from "../abstracts/Component";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";
import { algoliaAddToWishlist } from "../utils/algoliaTrackings";

export default class WishlistLogic extends Component {

  constructor() {
    super();
    this.liveRegion = new OnDemandLiveRegion({ level: 'assertive', delay: 1000 });
    this._eventsBound = false;
  }

  get CLASSES() {
    return {
      addBtnClass: "js-add-to-wish",
      addedBtnClass: "js-added-wish",
      removeBtnClass: "js-remove-from-wish",
      listingClassRemove: "icon-wishlist-full",
      listingClassAdd: "icon-wishlist-empty",
    };
  }

  get SELECTORS() {
    return {
      wishlistIcon: "[data-wishlist-icon]"
    }
  }
  // should be: every wishlistAdd and wishlistRemove call/logic here

  bindEvents() {
    if (this._eventsBound) return;
    this._eventsBound = true;
    const ctx = this;

    // event on add to wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({event, payload}) => {
      const btn = payload.elem;
      const addedMessage = payload.msg || btn?.dataset?.labelAdded;

      if (btn) {
        // adding and removing classes
        btn.setAttribute('aria-label', btn.dataset.removeMessage || btn.getAttribute('data-remove-message') || '');
        btn.classList.remove(ctx.CLASSES.addBtnClass);
        btn.classList.add(ctx.CLASSES.addedBtnClass);
        btn.classList.add(ctx.CLASSES.removeBtnClass);
        // listing
        if (btn.classList.contains(ctx.CLASSES.listingClassAdd)) {
          btn.classList.remove(ctx.CLASSES.listingClassAdd);
          btn.classList.add(ctx.CLASSES.listingClassRemove);
        }
        // ALGOLIA (dedupe per bottone)
        const productCode =
          btn.dataset.code ||
          btn.getAttribute('data-code') ||
          btn.closest('[data-code]')?.dataset.code;

        if (!productCode) {
          console.warn('[WishlistLogic] productCode non trovato per tracking.');
        } else {
          const algoliaQueryId =
            document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId ||
            document.querySelector('[data-algolia-search]')?.dataset?.algoliaSearch;

          if (!algoliaQueryId) {
            console.warn('[WishlistLogic] Algolia query ID non presente (ok se non arrivi da search).');
          }

          if (btn.dataset.algoliaWishTracked !== 'true') {
            try {
              algoliaAddToWishlist(productCode);
              btn.dataset.algoliaWishTracked = 'true';
            } catch (e) {
              console.warn('[WishlistLogic] algoliaAddToWishlist errore:', e);
            }
          }
        }
      }
      if (addedMessage) this.liveRegion.sayMessage(addedMessage);
    });

    // event on remove from wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      const btn = payload.elem; // <-- dichiara prima
      const removedMessage = payload.msg || btn?.dataset?.removedMessage;

      if (btn) {
        // reset dedupe flag solo se ho il bottone
        delete btn.dataset.algoliaWishTracked;
        const icon = btn.querySelector(ctx.SELECTORS.wishlistIcon);
        // update classes on btn
        // adding and removing classes
        btn.setAttribute('aria-label', btn.dataset.addMessage || btn.getAttribute('data-add-message') || '');
        btn.classList.remove(ctx.CLASSES.addedBtnClass, ctx.CLASSES.removeBtnClass);
        btn.classList.add(ctx.CLASSES.addBtnClass);
        // listing
        if (btn.classList.contains(ctx.CLASSES.listingClassRemove)) {
          btn.classList.remove(ctx.CLASSES.listingClassRemove);
          btn.classList.add(ctx.CLASSES.listingClassAdd);
        }
      }
      if (removedMessage) this.liveRegion.sayMessage(removedMessage);
    });

  }

  render() {
    this.bindEvents();
  }
}
